export const CATEGORIES = ['webapp', 'spa', 'native', 'backend'];
